<div class="container-fluid cw-background">
  <div class="row d-flex justify-content-center">
    <div class="col-12 col-sm-9 col-sm-offset-1 col-md-9 col-md-offset-1 col-lg-4 col-lg-offset-4 mb-5">
      <mat-card class="mat-elevation-z8 mt-5 pt-5 pb-5" id="card">
        <div class="d-flex justify-content-between">
          <div class="text-left go-back">
            <button (click)="goBack()" disableRipple mat-button class="delete-user">
              <mat-icon matPreffix>arrow_back_ios</mat-icon>
              Go Back
            </button>
          </div>
          <div class="text-left go-back">
            <button (click)="deleteUserModal()" disableRipple mat-button class="delete-user">
              <mat-icon matPreffix>cancel</mat-icon>
              Delete user
            </button>
          </div>
        </div>
        <h6 class="text-center card-title-page mb-4">Activate User:</h6>
        <div *ngIf="data" class="row d-flex justify-content-center">
            <app-dynamic-form [questions]="questions" (hasChanged)="onChange($event)" (formSubmit)="onSubmit($event)">
            </app-dynamic-form>
        </div>
      </mat-card>
    </div>
  </div>
</div>
